module.exports = __webpack_public_path__ + "img/es-pc-step-3.7c7009f8.png";